import React from "react";
import NotificationsListSection from "../../Sections/Notification/NotificationsList";
import Dashboard from "../Dashboard/Dashboard";

const NotificationsComponent = () => {
  return <Dashboard sectionName={<NotificationsListSection />} />;
};

export default NotificationsComponent;
